import { SHELL } from "../shell/shell.const";

const PROJECTS = 'proyecto';
const PROJECTS_INFO = '';
const PROJECTS_MARKET = 'mercado';
const PROJECTS_PURCHASE = 'inversion';
const PROJECTS_V2 = 'v2';

const PROJECTS_MARKET_ACTIVE = 'en-fondeo';

export const PROJECT_ROUTES = {
  PROJECTS,
  PROJECTS_INFO,
  PROJECTS_MARKET,
  PROJECTS_PURCHASE,
  PROJECTS_V2,

  PROJECTS_MARKET_ACTIVE,

  ROUTE_PROJECTS_INFO: `${SHELL}/${PROJECTS}/${PROJECTS_INFO}`,
  ROUTE_PROJECTS_MARKET: `${SHELL}/${PROJECTS}/${PROJECTS_MARKET}`,
  ROUTE_PROJECTS_MARKET_ACTIVE: `${SHELL}/${PROJECTS}/${PROJECTS_MARKET}/${PROJECTS_MARKET_ACTIVE}`,
  ROUTE_PROJECTS_PURCHASE: `${SHELL}/${PROJECTS}/${PROJECTS_PURCHASE}`,
  ROUTE_PROJECT_INFO_V2: `${SHELL}/${PROJECTS}/${PROJECTS_V2}`,
}
